"use client";

import { useEffect, useState } from "react";
import { useTheme } from "next-themes";
import Image from "next/image";
import cn from "classnames";

const Logo = ({ className }: { className?: string }) => {
  const [selectedTheme, setSelectedTheme] = useState<string | null>(null);

  const { theme, systemTheme } = useTheme();

  useEffect(() => {
    setSelectedTheme(theme === "system" ? systemTheme || "light" : theme || "light");
  }, [theme, systemTheme]);

  return (
    <>
      <Image
        src={"/logo-dark.svg"}
        width={0}
        height={0}
        sizes="100vw"
        alt="logo"
        className={cn("h-auto w-full max-w-[133px]", className, { hidden: selectedTheme === "light" })}
      />
      <Image
        src={"/logo-light.svg"}
        width={0}
        height={0}
        sizes="100vw"
        alt="logo"
        className={cn("h-9 w-auto max-w-[133px]", className, { hidden: selectedTheme === "dark" })}
      />
    </>
  );
};

export default Logo;
